import StripColumnsContainer_DesignedStripComponent from '../components/StripColumnsContainer/viewer/skinComps/DesignedStrip/DesignedStrip.skin';


const StripColumnsContainer_DesignedStrip = {
  component: StripColumnsContainer_DesignedStripComponent
};


export const components = {
  ['StripColumnsContainer_DesignedStrip']: StripColumnsContainer_DesignedStrip
};

